import { render, staticRenderFns } from "./problemManage.vue?vue&type=template&id=b150a202&scoped=true&"
import script from "./problemManage.vue?vue&type=script&lang=js&"
export * from "./problemManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b150a202",
  null
  
)

export default component.exports